import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {
  IGetStatusesRequestInterfaces,
} from '@toolify/server/src/controllers/StatusController/validators/GetStatuses/types/IGetStatusesRequestInterfaces'
import {
  ICreateStatusRequestInterfaces,
} from '@toolify/server/src/controllers/StatusController/validators/CreateStatus/types/ICreateStatusRequestInterfaces'
import {
  IStatusResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IStatusResponseInstance'
import {IUpdateStatusRequestInterfaces} from '@toolify/server/src/controllers/StatusController/validators/UpdateStatuses/types/IUpdateStatusRequestInterfaces'
import {IDeleteStatusRequestInterfaces} from '@toolify/server/src/controllers/StatusController/validators/DeleteStatus/types/IDeleteStatusRequestInterfaces'
import {createKeyedRequestCache} from '../keyedRequestCache'

const STATUSES_CACHE_TTL_MS = 60 * 1000
const statusesCacheByPropertyId = createKeyedRequestCache<IStatusResponseInstance[]>({ttlMs: STATUSES_CACHE_TTL_MS})

export const useStatusApiStore = defineStore('statusApi', {
  actions: {
    async getStatuses(databasePropertyId: string): Promise<IStatusResponseInstance[]> {
      return statusesCacheByPropertyId.get(databasePropertyId, async () => {
        const apiRequestStore = useApiRequestStore()
        const {statuses} = await apiRequestStore.get<IGetStatusesRequestInterfaces>(`/property/${databasePropertyId}/statuses`)
        return statuses
      })
    },

    async createStatus(databasePropertyId: string, data: unknown): Promise<IStatusResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {status} = await apiRequestStore.post<ICreateStatusRequestInterfaces>(`/property/${databasePropertyId}/status`, {
        data,
      })
      statusesCacheByPropertyId.invalidate(databasePropertyId)
      return status
    },

    async deleteStatus(statusId: unknown): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete<IDeleteStatusRequestInterfaces>(`/status/${statusId}`)
      statusesCacheByPropertyId.invalidateAll()
    },

    async updateStatus(statusId: string, data: unknown): Promise<IStatusResponseInstance> {
      const apiRequestStore = useApiRequestStore()
      const {status} = await apiRequestStore.patch<IUpdateStatusRequestInterfaces>(`/status/${statusId}`, {
        data,
      })
      statusesCacheByPropertyId.invalidateAll()
      return status
    },

    invalidateStatusesCache(databasePropertyId?: string): void {
      if(databasePropertyId) {
        statusesCacheByPropertyId.invalidate(databasePropertyId)
        return
      }
      statusesCacheByPropertyId.invalidateAll()
    },
  },
})
